import "./NavBarUserMenu.css";

import { TextButton } from "../../buttons/TextButton";
import { useNavigate } from "react-router-dom";

interface INavBarUserMenuProps {
    displayName: string | null;
    email: string | null;
    /** Identity account page ("View account"); hidden when absent. */
    accountUrl?: string;
    onClose: () => any;
}

// Presentational only. Closing on an outside click is done in NavBar with the shared
// useOutsideComponentClickTrigger hook, whose ref has to span the trigger as well as the menu.
export function NavBarUserMenu(props: INavBarUserMenuProps) {
    const navigate = useNavigate();

    return (
        <div className="nav-bar-user-menu">
            <div className="nav-bar-user-menu-identity">
                <div className="nav-bar-user-menu-name">{props.displayName ?? "Signed in"}</div>
                {props.email ? <div className="nav-bar-user-menu-email">{props.email}</div> : null}
            </div>

            {props.accountUrl ? (
                <TextButton
                    text="View account"
                    className="nav-bar-user-menu-btn"
                    type="white"
                    onClick={() => {
                        props.onClose();
                        window.open(props.accountUrl, "_blank", "noopener");
                    }}
                />
            ) : null}

            <TextButton
                text="Sign out"
                className="nav-bar-user-menu-btn"
                type="white"
                onClick={() => {
                    props.onClose();
                    // The route runs IdentityService.logout(), which clears this origin's storage
                    // (sign-in hints included, unlike the Session Expired reset) and then redirects
                    // to Entra to end the session.
                    navigate("/identity/logout");
                }}
            />
        </div>
    );
}
